var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"t-form-card",class:{ 't-form-card--coming-soon': _vm.comingSoon }},[_c('t-card',[(_vm.$slots.header)?_c('div',{staticClass:"t-form-card__header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"t-form-card__inner"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }